module.exports = __webpack_public_path__ + "img/cuowu.573a3505.png";